import { Asterisk } from "lucide-react";

const ITEMS = [
    "Luton Local Experts",
    "Property Maintenance",
    "Loft Extensions",
    "Kitchen Fitting",
    "Painting & Decorating",
    "Plumbing",
    "Smart Solutions",
];

export default function EditorialTicker() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <section data-testid="marquee-ticker" aria-hidden="true" className="bg-[#E85A1D] overflow-hidden py-4 border-y border-[#141414]/10">
            <div className="flex w-max animate-marquee">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center shrink-0">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-display font-extrabold uppercase tracking-tight text-white text-lg sm:text-xl whitespace-nowrap px-5">
                                    {item}
                                </span>
                                <Asterisk className="w-5 h-5 text-[#141414]" strokeWidth={2.5} />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
